import { TranslateLoader } from '@ngx-translate/core';

import { I18nDataLoadingService } from './i18n-data-loading.service';

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(private i18nDataLoadingService: I18nDataLoadingService) {}

  public getTranslation(lang: string): any {
    return this.i18nDataLoadingService.getTranslation(lang);
  }
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function translateLoader(i18nDataLoadingService: I18nDataLoadingService): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(i18nDataLoadingService);
}
